const emailErrorCodes = {
  'server-error-while-sending-email': 'Error del servidor mientras se envía el correo electrónico'
};

export default emailErrorCodes;
